import React from 'react';

import useMainBannerViewModel from '../hooks/useMainBannerViewModel';
import BannerContent from './BannerContent';
import BannerImage from './BannerImage';
import { MainBannerContainer } from './MainBannerAnimations';
import MedicalCategorySection from './MedicalCategorySection';

const MainBanner = () => {
  const { ref, currentBanner } = useMainBannerViewModel();

  return (
    <MainBannerContainer ref={ref}>
      <div className='flex w-full max-w-[1080px] flex-col desktop:pt-[80px] pb-[80px]'>
        <div className='relative flex w-full flex-1 desktop:flex-row flex-col justify-between desktop:gap-[56px] gap-[40px] px-[20px] desktop:py-[80px] pb-[48px] sm:flex-col sm:gap-[40px] sm:px-[0px]'>
          <BannerContent currentBanner={currentBanner} />
          <BannerImage currentBanner={currentBanner} />
        </div>
        <MedicalCategorySection />
      </div>
    </MainBannerContainer>
  );
};

export default MainBanner;
